import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { reportDWH } from '../../EnergyReplaceBlockSlice';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { buildUrlAndOpenWindow, buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';


const ErrorPage = (props) => {

    useEffect(() => {

    }, []);

    let title = '';
    let subTitle = '';
    let icon = '';
    let btnText = 'לאיזור האישי';
    let btnClassName = '';
    let displayServiceCenter = false;

    switch (props.errorPage) {
        case 'GENERAL_ERROR':
        case 'NOT_JET_CUSTOMER_ERROR':
        case 'NO_SUBSCRIBER_ERROR':
        case 'TAOZ_ERROR':
        case 'GET_PRICE_ERROR':
        case 'NO_PACKAGES_ERROR':
        case 'ACCOUNT_TYPE_ERROR':
        case 'CREATE_ENERGY_REPLACE_ERROR':
            title = <> משהו השתבש ולא הצלחנו <br/> להשלים את הפעולה </>;
            icon = 'error-icon';
            btnText = 'לאיזור האישי';
            btnClassName = 'btn-submit-white';
            break;
        case 'FUTURE_PRICE_PLAN_ERROR':
            title = <> למונה זה קיימת בקשה בטיפול <br/> למעבר תכנית </>;
            subTitle = <> שינוי נוסף יתאפשר לאחד עדכון התוכנית <br/> ב-1 לחודש הבא </>;
            icon = 'error-icon';
            btnText = 'לאיזור האישי';
            btnClassName = 'btn-submit-white';
            break;
        case 'HAS_OPEN_ORDER_ERROR':
            title = <> המונה נמצא בתהליך מעבר <br/> ל{window.Config.brand_Name_HE} Energy </>;
            subTitle = <> כדי להמשיך את הפעולה, יש להמתין <br/> לסיום התהליך </>;
            icon = 'error-icon';
            btnText = 'הבנתי, תודה';
            break;
        case 'ENERGY_BUNDLE_ERROR':
            title = <> מנוי החשמל שלך הוא חלק<br/> מחבילה משולבת </>;
            subTitle = null;
            icon = 'error-icon';
            btnText = 'לאיזור האישי';
            btnClassName = 'btn-submit-white';
            displayServiceCenter = true;
            break;
        case 'PAYMENT_ERROR':
            title = <> לפני שנמשיך בתהליך, <br/> יש לעדכן אמצעי תשלום </>;
            icon = 'credit-card-icon';
            btnText = 'לאיזור האישי';
            break;
        case 'DEBT_ERROR':
            title = <> לפני שנמשיך בתהליך, <br/> יש לשלם את החוב בחשבון </>;
            icon = 'credit-card-icon';
            btnText = 'לאיזור האישי';
            break;
        case 'PAYMENT_AND_DEBT_ERROR':
            title = <> לפני שנמשיך בתהליך,<br/> יש לשלם את  החוב בחשבון<br/> ולעדכן אמצעי תשלום </>;
            icon = 'credit-card-icon';
            btnText = 'לאיזור האישי';
            break;
    }

    return (
        <div className='energy-error-page' data-error={props.errorPage}>

            <div className={icon}></div>
            {title && <div className='page-title'> {title} </div>}
            {subTitle && <div className='page-sub-title'> {subTitle} </div>}

            {
                (!displayServiceCenter && props.errorPage != 'HAS_OPEN_ORDER_ERROR') &&
                <div className='link-wrapper'>
                    <a href={`tel:${Config.energyCallCenter || '*2266'}`}> לשיחה עם נציג <span>{Config.energyCallCenter || '*2266'}</span> </a>
                </div>
            }

            {
              displayServiceCenter &&
              <div className='service-center-wrapper'>
                  <div className='service-center-text'> כדי שנוכל להציע לך חבילות מתאימות< br/> ומשתלמות יש לפנות לנציג <span className='call-center-wrapper'>ב- <span className='call-center'>{Config.energyCallCenter || '*900'}</span></span> </div>
                  <a className='call-center-link' href={`tel:${Config.energyCallCenter || '*2266'}`}> תעבירו אותי לנציג <span className='call-center'> {Config.energyCallCenter || '*2266'} </span> </a>
              </div>
            }

            <div className='button-wrapper'>
                <BtnSubmit
                    text={btnText}
                    onclick={handleOnContinue}
                    formid='error-page'
                    className={btnClassName}
                />
            </div>

        </div>
    );


    function handleOnContinue() {
        buildUrlAndOpenSameWindow(Config.selfCareElectricityLink);
    }

};

const mapStateToProps = (state) => {
    return {
        errorPage: state.energyReplaceBlock.errorPage
    };
};

const mapDispatchToProps = {
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
